<app-navbar></app-navbar>

<section class="parallax-bg fixed-bg xxl-screen pt-0 pb-0" style="background-image: url('assets/images/zatoglav-slike/background.jpg')" id="home">
    <div class="hero-text-wrap xxl-screen">
        <div class="hero-text">
            <div class="text-content-slider">
                <owl-carousel-o [options]="customOptions" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStore">
                        <div class="container">
                            <div class="row d-flex justify-content-center">
                                <div class="col-md-8">
                                    <div class="all-padding-50 text-center white-color">
                                        <h1>{{slide.introtext}}</h1>
                                        <h2 class="font-100 raleway-font">{{slide.subtitle}}</h2>
                                    </div>
                                </div> 
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>


<section class="white-bg xs-pb-100" id="features" style="padding-top:30px;">
    <div class="container">
        <div class="row">
            <h2 class="raleway-font" style="text-align: center;">Kontaktiraj nas</h2>
            <div *ngFor="let item of features;" class="col-md-4 col-sm-4 col-xs-12 mb-30 hover-effect">
                <div [ngClass]="item.featureBox">
                    <i [ngClass]="item.icon"></i>
                    <h4 class="mt-0 font-600">{{item.title}}</h4>
                    <p class="font-400" [innerHTML]="item.desc">{{item.desc}}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="bordered-bg white-bg lg-section xs-pb-100 xs-pt-100" id="aboutObject">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-right">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/zatoglav-slike/background.jpg);"></div>
    </div>
    <div class="container">
        <div class="col-md-5 col-sm-6">
            <div class="section-title mb-50">
                <h2 class="raleway-font red-color mt-0 font-20px">Rogoznica, Hrvatska</h2>
                <h1 class="raleway-font mt-0 font-50px font-300">Objekt B Residence</h1>
            </div>
            <p style="padding:10px">Objekt B Residence je dvokatna/zgrada (adaptirajte po stvarnom statusu) rezidencija dizajnirana za one koji traže udobnost, blizinu mora i visoku kvalitetu gradnje.
               Svaki apartman nudi prostrani dnevni boravak s kuhinjom, jednu ili više spavaćih soba, balkone/terase okrenute prema marini te velike staklene površi koje donose svjetlost i panoramski pogled.<br>
               Lokacija — svega 50 m od čiste obale i sa direktnim pristupom pješačkim stazama uz more — čini ovaj projekt idealnim za ljetni najam, ali i kao stalni boravak.<br>
               Standard opreme uključuje modularnu kuhinju po mjeri, kvalitetne podne obloge, modernu sanitariju, klima uređaje, pripremu za grijanje, te osigurana parkirna mjesta. <br> 
               Mogućnosti: prodaja namješteno/nenamješteno, najam za turizam ili dugoročno.</p>
        </div>
    </div>
</section>
<section class="white-bg lg-section xs-pt-10 xs-pb-0">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-left">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/zatoglav-slike/omis-zgrada/bg-omis.jpg);"></div>
    </div>
    <div class="container">
        <div class="col-md-5 col-sm-6 offset-md-7 offset-md-6">
            <div class="section-title mb-50">
                 <h2 class="raleway-font red-color mt-0 font-20px">Omiš, Hrvatska</h2>
                <h1 class="raleway-font mt-0 font-50px font-300">SeaView Omiš Residence</h1>
            </div>
            <p style="padding:10px">SeaView Omiš Residence je ekskluzivni stambeni projekt smješten na uzvisini iznad Omiša, s pogledom koji oduzima dah.<br>
               Svaki apartman dizajniran je tako da maksimalno iskoristi prirodno svjetlo i neometan pogled prema moru i otocima Braču i Šolti.<br>
               Projekt spaja suvremenu arhitekturu, funkcionalne tlocrte i vrhunske materijale.<br>
               Apartmani imaju prostrane terase, staklene stijene od poda do stropa, moderne kuhinje, elegantne kupaonice i privatna parkirna mjesta.<br>
               U prizemlju je moguća ugradnja jacuzzija ili bazena, dok se u višim etažama pruža spektakularan pogled na more iz svake prostorije.<br>
               Smještena samo nekoliko minuta od centra Omiša i plaža, SeaView Omiš Residence predstavlja savršen balans između mira, luksuza i blizine svih sadržaja.</p>
        </div>
    </div>
</section> 

<section class="grey-bg" id="portfolio" id="view">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">Pogledajte naš rad izbliza</h2>
                    <h1 class="raleway-font">B residence</h1>
                </div>
                <p>B Residence predstavlja savršen spoj elegancije i udobnosti, gdje svaki arhitektonski detalj ima svoju priču. Naš pristup dizajnu temelji se na stvaranju prostora koji odišu toplinom, modernim linijama i funkcionalnošću. Pogledajte kako smo spojili savremene materijale s prirodnim svjetlom, stvarajući ambijent koji inspiriše život u punom skladu.</p>
            </div>
        </div>
    </div>

    <section id="home" class="slider-section">
  <owl-carousel-o [options]="customOptions" class="owl-theme">
    <ng-template carouselSlide *ngFor="let img of slideImages">
      <div class="slide-bg" [ngStyle]="{'background-image': 'url(' + img + ')'}"></div>
    </ng-template>
  </owl-carousel-o>
</section>
</section>


<section class="grey-bg" id="portfolio" id="view">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">Pogledajte naš rad izbliza</h2>
                    <h1 class="raleway-font">Omiš residence</h1>
                </div>
                <p>Omiš Residence je simbol savremene estetike smješten u srcu mediteranskog pejzaža. Naš dizajn naglašava jednostavnost, prozračnost i sklad s okolinom. Svaka fotografija prikazuje pažljivo birane detalje – od fasadnih tekstura do savršeno oblikovanih terasa koje nude pogled na more i osjećaj potpunog mira.</p>
            </div>
        </div>
    </div>

    <section id="home" class="slider-section">
  <owl-carousel-o [options]="customOptions" class="owl-theme">
    <ng-template carouselSlide *ngFor="let img of slideImages3">
      <div class="slide-bg" [ngStyle]="{'background-image': 'url(' + img + ')'}"></div>
    </ng-template>
  </owl-carousel-o>
</section>
</section>


<section class="white-bg lg-section xs-pt-10 xs-pb-0" id="aboutUs">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-left d-none d-md-block">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/zatoglav-slike/construction.jpg);height:960px;width:670px;"></div>
    </div>
    <div class="container">
        <div class="col-md-5 col-sm-6 offset-md-7 offset-md-6">
            <div class="section-title mb-50">
                <h2 class="raleway-font red-color mt-1 font-20px">Partneri smo</h2>
                <h1 class="raleway-font mt-0 font-50px font-300">O nama</h1>
            </div>
            <p style="padding:10px">ADRIA HOME
Naša posvećenost gradnji temelji se na iskustvu, preciznosti i pažnji prema svakom detalju. Svaki projekt doživljavamo kao priliku da stvorimo kvalitetan, funkcionalan i estetski privlačan prostor koji odgovara potrebama modernog života.<br><br>

Naš tim čine stručnjaci s dugogodišnjim iskustvom koji s predanošću pristupaju svakom zadatku, nastojeći ostvariti visoke standarde koje njegujemo u svakom projektu.<br><br>

Svjesni smo da zgrada nije samo objekt, već prostor u kojem se stvaraju svakodnevni trenuci i uspomene. Zato pomno slušamo želje naših klijenata, prilagođavamo se njihovom načinu života i zajednički stvaramo prostor koji savršeno odgovara njihovim potrebama.<br><br>

Povjerenje, otvorena komunikacija i profesionalizam temelj su naših odnosa s klijentima i partnerima. Zadovoljstvo i preporuka onih koji nam ukazuju povjerenje najbolja su potvrda našeg rada.<br><br>

Ako tražite pouzdanog partnera za gradnju i nekretnine, ADRIA HOME je tu da vas prati na svakom koraku.</p>
        </div>
    </div>
</section> 

<section class="parallax-bg fixed-bg pt-80 pb-80" style="background-image: url('assets/images/zatoglav-slike/under.jpg')">
    <div class="overlay-bg"></div>
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="section-title mb-50 white-color text-center">
                    <h1 class="raleway-font remove-margin font-50px font-300">Do sada smo uspješno izgradili</h1>
                </div>
            </div>
        </div>
        <div class="row our-process-style-02">
            <div *ngFor="let step of steps" class="col-md-3 col-sm-6 col-xs-12 line xs-mb-30 sm-mb-30">
                <div class="icon-wrap white-bg">
                    <div class="icon">
                        <i [ngClass]="step.icon"></i>
                    </div>
                </div>
                <div class="text-center white-color">
                    <h4 class="font-500">{{step.title}}</h4>
                    <p class="mb-0">{{step.desc}}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="white-bg xs-pb-100" id="features2" style="padding-top:30px;" id="tehnical">
    <div class="container">
        <div class="row">
            <h2 class="raleway-font" style="text-align: center;">Tehnički podaci</h2>
            <div *ngFor="let item of features2;" class="col-md-16 col-sm-6 col-xs-12 mb-4 p-3 hover-effect">
                <div [ngClass]="item.featureBox" id="tee">
                    <i [ngClass]="item.icon"></i>
                    <h4 class="mt-0 font-600">{{item.title}}</h4>
                    <p class="font-400" [innerHTML]="item.desc">{{item.desc}}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!--<section class="white-bg pb-80" id="services">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">What We Offer</h2>
                    <h1 class="raleway-font">Our Services</h1>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam semper ex ac velit varius semper.
                    Mauris at dolor nec ante ultricies aliquam ac vitae diam. Quisque sodales vehicula elementum.
                    Phasellus tempus tellus vitae ullamcorper hendrerit.</p>
            </div>
        </div>

        <div class="row mt-50">
            <div *ngFor="let service of services" class="col-md-4 col-sm-4 col-xs-12 mb-30 feature-box text-center hover-effect">
                <div class="gradient-bg-icon mb-20">
                    <i [ngClass]="service.icon"></i>
                </div>
                <h5 class="mt-10">{{service.title}}</h5>
                <p class="font-400">{{service.desc}}</p>
            </div>
        </div>

    </div>
</section>-->

<!--<section class="gray-bg" id="about">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">We Are Becki</h2>
                    <h1 class="raleway-font">About Company</h1>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam semper ex ac velit varius semper.
                    Mauris at dolor nec ante ultricies aliquam ac vitae diam. Quisque sodales vehicula elementum.
                    Phasellus tempus tellus vitae ullamcorper hendrerit.</p>
            </div>
        </div>
        <div class="row mt-50">
            <div class="col-md-7 col-xs-12">
                <img class="img-responsive" src="assets/images/responsive-screen-2.png" alt="laptop">
            </div>
            <div class="col-md-5 mt-30 col-xs-12">
                <div class="skillbar-wrap skillbar-style-01">
                    <div *ngFor="let skill of skills">
                        <div class="skillbar">
                            <span class="skillbar-title text-uppercase">{{ skill.name }}</span>
                            <p class="skillbar-bar gradient-bg" role="progressbar" [style.width]="skill.level + '%'" [attr.aria-valuenow]="skill.level" aria-valuemin="0" aria-valuemax="100"></p>
                            <span class="skill-bar-percent">{{ skill.level }}%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section> -->

<section class="gradient-bg xs-pb-60">
  <div class="col-md-6 col-sm-6 bg-flex bg-flex-left">
    <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/zatoglav-slike/background.jpg);">
      <div class="video-box_overlay">
        <div class="center-layout">
          <div class="v-align-middle">

            <!-- Video Thumbnail (shown before playing) -->
            <div class="video-thumbnail" *ngIf="!isVideoPlaying">
              <img src="assets/images/zatoglav-slike/background.jpg" alt="Video preview" />
              <a (click)="playVideo()" class="play-button-wrapper">
                <div class="play-button">
                  <i class="tr-icon ion-android-arrow-dropright"></i>
                </div>
              </a>
            </div>

            <!-- Actual Video -->
            <video
              #localVideo
              width="100%"
              height="auto"
              controls
              preload="none"
              style="display: none; border-radius: 10px;"
            >
              <source src="assets/images/zatoglav-slike/video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="col-md-6 col-sm-6 offset-md-6">
      <div class="col-inner spacer white-color text-center">
        <h2 class="raleway-font mt-0 font-20px xs-font-17px">Naša priča</h2>
        <h1 class="raleway-font mt-0 font-50px font-300 xs-font-27px">Pogledajte naš video</h1>
        <p>
          Doživite naše nekretnine iz svakog ugla uz 360° virtualni obilazak.<br> Savršen način da pronađete svoj idealni prostor.
        <p>
        </p>
      </div>
    </div>
  </div>
</section>



<section class="grey-bg" id="portfolio">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title">
                    <h2 class="raleway-font default-color">Naš stambeni kompleks</h2>
                    <h1 class="raleway-font">Tlocrt projekta</h1>
                </div>
                <p>
                      Pogledajte skicu i vizualni prikaz našeg novog objekta. 
                      Projekat je osmišljen s modernim arhitektonskim rješenjima, 
                      vrhunskim materijalima i udobnošću koja zadovoljava najviše standarde stanovanja.
                </p>
            </div>
        </div>
    </div>

    <section id="home" class="slider-section">
  <owl-carousel-o [options]="customOptions" class="owl-theme">
    <ng-template carouselSlide *ngFor="let img of slideImages2">
      <div class="slide-bg" [ngStyle]="{'background-image': 'url(' + img + ')'}"></div>
    </ng-template>
  </owl-carousel-o>
</section>




<!--<section class="grey-bg" id="pricings">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title mb-50">
                    <h2 class="raleway-font default-color">Select Your Plan</h2>
                    <h1 class="raleway-font">Our Pricing Table</h1>
                </div>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam semper ex ac velit varius semper.
                    Mauris at dolor nec ante ultricies aliquam ac vitae diam. Quisque sodales vehicula elementum.
                    Phasellus tempus tellus vitae ullamcorper hendrerit.</p>
            </div>
        </div>
        <div class="row mt-50">
            <div *ngFor="let price of pricing; let i = index" class="col-md-4 pricing-table col-sm-4 xs-mb-30 hover-effect">
                <div
                    class="pricing-box border-radius-25 {{ i === 1 ? 'pricing-box-gradient-two' : 'pricing-box-gradient' }} text-center white-color">
                    <h3 class="mb-0 raleway-font">{{price.title}}</h3>
                    <h4>{{price.subTitle}}</h4>
                    <h2 class="font-60px sm-font-40px"><sup>{{price.currency}}</sup><span>{{price.amount}}</span></h2>
                    <ul class="list-style-02">
                        <li *ngFor="let feature of price.features">{{ feature }}</li>
                    </ul>
                    <div class="pricing-box-bottom"> <a [ngClass]="price.btnClass">{{price.btnText}}</a> </div>
                </div>
            </div>
        </div>
    </div>
</section> -->


<section class="white-bg">
    <div class="container">
        <div class="row">
            <div class="col-md-8 centerize-col text-center">
                <div class="section-title mb-50">
                    <h2 class="raleway-font default-color" style="padding:10px">Šta naši klijenti kažu</h2>
                    <h1 class="raleway-font">Recenzije</h1>
                </div>
               <p>Naši klijenti su zadovoljni iskustvom kupnje stanova preko naše agencije. <br>
                Svaka recenzija odražava profesionalnost našeg tima, posvećenost detaljima i brigu da svaki klijent pronađe svoj idealan dom. <br>
                Pročitajte što kažu oni koji su već ostvarili svoj san o savršenom stanu.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <owl-carousel-o [options]="customOptionsThree" class="testimonial owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStoreThree">
                        <div class="testimonial-item">
                            <div class="testimonial-content border-radius-25">
                                <img class="img-responsive rounded-circle text-center" src="{{slide.image}}" alt="" />
                                <h4 class="font-600 mb-0 raleway-font">{{slide.title}}</h4>
                                <div class="clearfix mb-20"></div>
                                <i class="icofont icofont-quote-left font-50px default-color mt-20"></i>
                                <p class="mt-20 line-height-26 font-14px">{{slide.description}}</p>
                            </div>
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>
    </div>
</section>

<!--<div class="grey-bg pt-120 pb-120">
    <div class="container">
        <div class="row">
            <div class="client-slider">
                <owl-carousel-o [options]="customOptionsFour" class="owl-btn-center-lr">
                    <ng-template carouselSlide *ngFor="let slide of slideStoreFour">
                        <div class="client-logo">
                            <img class="img-responsive" src="{{slide.image}}" alt="01" />
                        </div>
                    </ng-template>
                </owl-carousel-o>
            </div>
        </div>

    </div>
</div>-->

<!--<section class="gradient-bg-two xs-pb-60" id="blog">
    <div class="col-md-6 col-sm-6 bg-flex bg-flex-right">
        <div class="bg-flex-holder bg-flex-cover" style="background-image: url(assets/images/blog-img.jpg);"></div>
    </div>
    <div class="container-fluid">
        <div class="col-md-6 col-sm-6">
            <div class="col-inner spacer white-color text-center">
                <h2 class="raleway-font mt-0 font-20px xs-font-17px">Read Our News</h2>
                <h1 class="raleway-font mt-0 font-50px font-300 xs-font-27px">Latest Blog Post</h1>
                <p>Objectively innovate empowered manufactured products whereas parallel platforms.<br> Holisticly
                    predominate extensible testing procedures for reliable supply chains. </p>
                <p><a routerLink="/blog-details" class="btn btn-md btn-square btn-light-outline mt-30">See Blog Details</a></p>
            </div>
        </div>
    </div>
</section>-->

<section class="white-bg transition-none" id="contact">
  <div class="container">
    <div class="row">
      <div class="col-md-8 centerize-col text-center">
        <div class="section-title">
          <h2 class="raleway-font default-color">Zakažite na vrijeme</h2>
          <h1 class="raleway-font">Kontaktirajte nas</h1>
        </div>
        Naša kontakt sekcija dostupna je 0-24 za sve Vaše upite i potrebe. Možete nas kontaktirati putem telefona, e-maila ili društvenih mreža. Tu smo da odgovorimo na sva Vaša pitanja i pružimo podršku u najkraćem mogućem roku.
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row mt-70 text-center">
      <!-- Poštanska adresa -->
      <div class="col-md-4 col-sm-12 mb-4">
        <div class="section-title">
          <h2 class="raleway-font default-color">Poštanska adresa</h2>
          <p class="mt-30">
            Šibenska Rogoznica, Hrvatska<br>
            Omiš, Dalmacija
          </p>
        </div>
      </div>

      <!-- Kontakt brojevi -->
      <div class="col-md-4 col-sm-12 mb-4">
        <div class="section-title">
          <h2 class="raleway-font default-color">Kontakt brojevi</h2>
          <p class="mb-0 mt-30">Telefon (BiH): ‪+387 63 407 660‬ (WhatsApp / Viber)</p>
          <p class="mb-0">Telefon (HR): ‪+385 97 643 6386‬</p>
        </div>
      </div>

      <!-- Naš e-mail -->
      <div class="col-md-4 col-sm-12 mb-4">
        <div class="section-title">
          <h2 class="raleway-font default-color">Naš e-mail</h2>
          <p class="mb-0 mt-30">
              E-mail:
              <a href="mailto:aquaconcept10&#64;gmail.com">aquaconcept10&#64;gmail.com</a>
            </p>
        </div>
      </div>
    </div>

    <!-- Social icons row -->
    <div class="row mt-20">
      <div class="col-md-12 social-icons-style-01 text-center">
        <ul class="md-icon left-icon">
          <li *ngFor="let social of socialMedia">
            <a [ngClass]="social.iconClass" href="javascript:void(0)">
              <i [ngClass]="social.icon"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
